import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

import { PostHogPageView } from "./posthogPageView";

export function PostHogProvider({ children }) {
  useEffect(() => {
    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

    if (!posthogKey || !posthogHost) {
      console.warn("⚠️ [PostHog] API Key is missing!");

      return;
    }

    try {
      // Docs: https://posthog.com/docs/libraries/next-js
      posthog.init(posthogKey, {
        api_host: posthogHost,
        autocapture: true, // Enable automatic event tracking (clicks, inputs)
        capture_pageview: true, // Track page views
        capture_pageleave: true, // Track page exits
        rageclick: true, // Detect repeated clicks (user frustration)
        debug: true, // Enable console logs for debugging
        persistence: "localStorage", // Store user data locally
        mask_all_text: false, // Allow text capturing (disable for PII)
        mask_all_element_attributes: false, // Capture element attributes
        enable_recording_console_log: true, // Capture console logs
        disable_session_recording: false, // Enable session recording
        disable_surveys: false, // Enable surveys
      });

      console.log("✅ PostHog initialized:", posthog);
    } catch (error) {
      console.warn("❌ [PostHog] failed to initialize", error);
    }
  }, []);
  if (
    !process.env.REACT_APP_POSTHOG_KEY ||
    !process.env.REACT_APP_POSTHOG_HOST
  ) {
    return <>{children}</>;
  }

  return (
    <PHProvider client={posthog}>
      <PostHogPageView />
      {children}
    </PHProvider>
  );
}
